<template>
  <div class="h-screen flex flex-col relative" v-loading.fullscreen.lock="loading">
    <Header />

    <div class="min-h-0 flex-1 flex overflow-hidden">
      <Sidebar />

      <main class="min-w-0 flex-1 border-t border-gray-200">
        <section class="min-w-0 flex-1 h-full flex flex-col p-5 overflow-y-auto">
          <router-view v-slot="{ Component }">
            <component :is="Component" />
          </router-view>
          <div
            class="flex flex-col-reverse md:flex-row lg:flex-row justify-between items-center mt-5 gap-2"
          >
            <p class="text-xs text-gray-500">
              {{ $t('label.copyright') }}
            </p>
            <LanguageSwitcher />
          </div>
        </section>
      </main>
      <Dialog :open="isOpen" :isClose="false">
        <div class="flex flex-col items-center justify-center w-full">
          <div class="text-xl text-gray-500 mb-5">
            {{ statusCode === 500 ? $t('error.deletedUser') : $t('error.sessionTimeout') }}
          </div>
          <button
            @click="logout"
            class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none"
          >
            {{ $t('button.signin') }}
          </button>
        </div>
      </Dialog>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent } from 'vue'
import { useStore } from 'vuex'
import Header from './components/Header/index.vue'
import Sidebar from './components/Sidebar/index.vue'
import LanguageSwitcher from './components/LanguageSwitcher/index.vue'
import { useCookies } from 'vue3-cookies'
import { AUTH_TOKEN_KEY, ID_TOKEN_KEY, REFRESH_TOKEN_KEY } from 'core/constants'

export default defineComponent({
  name: 'DefaultLayout',
  components: {
    Header,
    Sidebar,
    LanguageSwitcher,
  },
  setup() {
    const store = useStore()
    const loading = computed(() => store.state.loading)
    const isOpen = computed(() => store.state.isOpen)
    const statusCode = computed(() => store.state.statusCode)
    const { cookies } = useCookies()
    const ERROR_CODE = [403, 500]

    const logout = computed(() => {
      if (ERROR_CODE.includes(statusCode.value)) {
        cookies.remove(AUTH_TOKEN_KEY)
        cookies.remove(ID_TOKEN_KEY)
        cookies.remove(REFRESH_TOKEN_KEY)
      }
      return (window.location.href = '/login')
    })
    return {
      loading,
      isOpen,
      statusCode,
      logout,
    }
  },
})
</script>
